import { Box, Button, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Select, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import './vehiclesModal.css';

const VehiclesModal = ({ onOpen, onClose, userVehicles, updateData }) => {
    const [vehicles, setVehicles] = useState(userVehicles);
    const [isVehiclesChanged, setIsVehiclesChanged] = useState(false);

    useEffect(() => {
        setIsVehiclesChanged(JSON.stringify(userVehicles) !== JSON.stringify(vehicles));
    }, [vehicles, userVehicles]);

    const handleStatusChange = (id, newStatus) => {
        const updatedVehicles = vehicles.map(vehicle =>
            vehicle.id === id ? { ...vehicle, status: newStatus } : vehicle
        );
        setVehicles(updatedVehicles);
    };

    const handleBillingChange = (id, newBilling) => {
        const updatedVehicles = vehicles.map(vehicle =>
            vehicle.id === id ? { ...vehicle, billing: newBilling } : vehicle
        );
        setVehicles(updatedVehicles);
    };

    const handleConfirm = () => {
        updateData({ vehicles });
        onClose(false);
    };

    const handleCloseModal = () => {
        setIsVehiclesChanged(false);
        onClose(false);
    };

    return (
        <Modal open={onOpen} onClose={handleCloseModal}>
            <Box className="modal_box vehicles_modal">
                <h2 style={{ textAlign: 'center' }}>Vehículos del usuario</h2>
                <TableContainer>
                    <Table className='vehicles_table'>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: 'var(--color-primary)', zIndex: 1 }}>
                                <TableCell sx={{ width: '100px', color: 'var(--color-white)' }}>ID</TableCell>
                                <TableCell sx={{ color: 'var(--color-white)' }}>Nombre</TableCell>
                                <TableCell sx={{ width: '250px', color: 'var(--color-white)' }}>Estatus</TableCell>
                                <TableCell sx={{ width: '120px', color: 'var(--color-white)', textAlign: 'center' }}>
                                    En facturación
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {vehicles.map(vehicle => (
                                <TableRow key={vehicle.id}>
                                    <TableCell><span>{vehicle.id}</span></TableCell>
                                    <TableCell><span>{vehicle.label}</span></TableCell>
                                    <TableCell>
                                        <Select
                                            value={vehicle.status}
                                            onChange={(e) => handleStatusChange(vehicle.id, e.target.value)}
                                            sx={{
                                                width: '70%',
                                                textAlign: 'start',
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--color-dark-variant)', // Color del borde por defecto
                                                },
                                                '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--color-dark)', // Color del borde al pasar el mouse
                                                },
                                                '& .MuiInputBase-input': {
                                                    color: 'var(--color-dark)',
                                                    fontSize: '0.65rem', // Tamaño del texto de entrada
                                                    padding: '0.2rem 12px'
                                                },
                                                '& .MuiSvgIcon-root': { color: 'var(--color-dark)' }, // Color del ícono
                                            }}
                                        >
                                            <MenuItem value="activo" style={{ fontSize: '0.7rem' }}>Activo</MenuItem>
                                            <MenuItem value="inactivo" style={{ fontSize: '0.7rem' }}>Inactivo</MenuItem>
                                        </Select>
                                    </TableCell>
                                    <TableCell>
                                        <Select
                                            value={vehicle.billing ?? false}
                                            onChange={(e) => handleBillingChange(vehicle.id, e.target.value)}
                                            sx={{
                                                width: '70%',
                                                textAlign: 'start',
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--color-dark-variant)',
                                                },
                                                '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'var(--color-dark)',
                                                },
                                                '& .MuiInputBase-input': {
                                                    color: 'var(--color-dark)',
                                                    fontSize: '0.65rem',
                                                    padding: '0.2rem 12px'
                                                },
                                                '& .MuiSvgIcon-root': {
                                                    color: 'var(--color-dark)'
                                                },
                                            }}
                                        >
                                            <MenuItem value={true} style={{ fontSize: '0.7rem' }}>Sí</MenuItem>
                                            <MenuItem value={false} style={{ fontSize: '0.7rem' }}>No</MenuItem>
                                        </Select>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box className="button_container">
                    <Button onClick={handleCloseModal} className="cancel_button">
                        Cancelar
                    </Button>
                    <Button onClick={handleConfirm} className="accept_button" disabled={!isVehiclesChanged}>
                        Confirmar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default VehiclesModal;
